import { useRef } from "react";
import { motion, useInView } from "framer-motion";
import { useLang } from "@/context/LanguageContext";
import translations from "@/data/translations";
import AnimatedSection from "./AnimatedSection";

const ValueProposition = () => {
  const { lang } = useLang();
  const t = translations[lang].valueProposition;
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-60px" });

  return (
    <section id="value-proposition" data-testid="value-proposition-section" className="bg-white py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-5 md:px-10">
        <AnimatedSection>
          <p className="text-xs md:text-sm uppercase tracking-[0.2em] font-semibold text-electric mb-4 font-body">
            {t.overline}
          </p>
          <h2 className="text-3xl md:text-5xl font-bold tracking-tight text-navy font-heading mb-12 max-w-md">
            {t.headline}
          </h2>
        </AnimatedSection>

        <div ref={ref} className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-0">
          {t.items.map((item, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, x: i % 2 === 0 ? -15 : 15 }}
              animate={isInView ? { opacity: 1, x: 0 } : {}}
              transition={{ duration: 0.4, delay: i * 0.06 }}
              data-testid={`value-item-${i}`}
              className="flex items-baseline gap-4 py-4 border-b border-slate-100 group"
            >
              <span className="text-electric/40 font-heading font-black text-sm shrink-0 w-6 group-hover:text-electric transition-colors">
                {item.num}
              </span>
              <p className="font-body text-sm md:text-base">
                <span className="font-bold text-navy">{item.title}</span>
                <span className="text-slate-400 ml-1">{item.desc}</span>
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ValueProposition;
